export function arraysEquals(arr1: number[], arr2: number[]): boolean {
    if (arr1.length !== arr2.length) {
        return false;
    }

    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
}

export function anyArraysEquals(arr1: any, arr2: any): boolean {
    if (arr1.length !== arr2.length) {
        return false;
    }

    const stringifyArr1 = [...arr1].map((item) => JSON.stringify(item));
    const stringifyArr2 = [...arr2].map((item) => JSON.stringify(item));

    return !stringifyArr1.some((item) => !stringifyArr2.includes(item) && !stringifyArr2.some((item) => !stringifyArr1.includes(item)));
}
